/* eslint-disable */
const $ = require('jquery');
const _ = require('lodash');
const Headroom = require('headroom.js');


class Header {

    constructor() {
        this.$header = $('.header');
        this.heroHeight = $('.js-hero').height();
        this.headerHeight = this.$header.height();
        this.resizeOnClass = 'header--onhero';
        this.resizeOffClass = 'header--offhero';

        this.setupHeadroom();
        this.addEventListeners();
    }

    addEventListeners() {
        $(window).on('scroll', _.throttle(()=> {
            this.resizeHeader();
        }, 100)).trigger('scroll');
    }

    setupHeadroom() {
        var headroom  = new Headroom(this.$header[0], {
            offset: 50
        });
        headroom.init();
    }

    resizeHeader() {
        if ($(window).scrollTop() < (this.heroHeight - this.headerHeight)) {
            this.$header.addClass(this.resizeOnClass);
            this.$header.removeClass(this.resizeOffClass);
        } else {
            this.$header.addClass(this.resizeOffClass);
            this.$header.removeClass(this.resizeOnClass);
        }
    }
}

export default new Header();
